// src/icons/ArrowBackIcon.tsx
import SvgIcon from "@mui/joy/SvgIcon";
import { jsx } from "react/jsx-runtime";
var ArrowBackIcon = (props) => {
  const Svg = () => /* @__PURE__ */ jsx("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" });
  return /* @__PURE__ */ jsx(SvgIcon, { ...props, viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Svg, {}) });
};
var ArrowBackIcon_default = ArrowBackIcon;

export {
  ArrowBackIcon_default
};
